export class VnaCampaignSelected {
    private pkCampaign: number;

    constructor(pkCampaign: number) {
        this.pkCampaign = pkCampaign;
    }

    getPkCampaign(): number {
        return this.pkCampaign;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/model/vna_campaign_selected.ts